import React from 'react';
import logo from '../../images/logo.png';

const IconLogo = () => <img src={logo} alt="Logo" style={{ width: '92px', height: '92px' }} />;

export default IconLogo;
